"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.clearStoredDomain = clearStoredDomain;
exports.getUserDomain = getUserDomain;
exports.parseDomain = parseDomain;
exports.writeDomainCookie = writeDomainCookie;
var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url-search-params"));
var _reverse = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reverse"));
var _constants = require("../constants");
var _cookies = require("./cookies");
function parseDomain(userDomain) {
  let domain;
  const match = userDomain.match(_constants.EMAIL_REGEX);
  if (match && match[2]) {
    domain = match[2];
  }
  return domain;
}
function getUserDomain() {
  const urlParams = new _urlSearchParams.default(window.location.search);
  if (urlParams.get('resetAuUserDomain')) {
    //Reset the console domain cookie
    clearStoredDomain();
  }
  const localStorageDomain = localStorage.getItem(_constants.USER_DOMAIN_KEY);
  const cookiedDomain = getCookiedUserDomain();

  //There's a path where the cookie can specify the domain, but it doesn't
  //exist in localStorage. Prefer local storage if for no reason than the
  //cookie has an expiration.
  if (cookiedDomain && !localStorageDomain) {
    localStorage.setItem(_constants.USER_DOMAIN_KEY, cookiedDomain);
  }
  return process.env.REACT_APP_USER_DOMAIN || urlParams.get('domain') || localStorageDomain || cookiedDomain;
}
function getCookiedUserDomain() {
  let domain = (0, _cookies.getCookie)(_constants.USER_DOMAIN_KEY);

  //Address condition where sometimes a null can be accidentally stored in the
  //cookie. empty string is already falsy.
  if (domain) {
    if (domain === 'null' || domain === 'false') {
      //clear out the bogus cookie just in case.
      (0, _cookies.deleteCookie)(_constants.USER_DOMAIN_KEY);
    } else {
      return domain;
    }
  }
}
function writeDomainCookie(domain) {
  if (domain && !getCookiedUserDomain()) {
    var _context;
    //find the root of the domain
    let temp = (0, _reverse.default)(_context = location.hostname.split('.')).call(_context);
    let rootDomain = (temp[1] ? '.' + temp[1] + '.' : '') + temp[0]; //handle localhost
    (0, _cookies.setCookie)(_constants.USER_DOMAIN_KEY, domain, 120, rootDomain);
  }
}
function clearStoredDomain() {
  localStorage.removeItem(_constants.USER_DOMAIN_KEY);
  (0, _cookies.deleteCookie)(_constants.USER_DOMAIN_KEY);
}